import { Button } from '@/components/ui/button';
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogDescription,
	DialogFooter,
} from '@/components/ui/dialog';
import useDeleteWish from '../hooks/useDeleteWish';
import { Gift, Trash } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import useMarkAsGifted from '../hooks/useMarkAsGifted';
import useGetWishes from '../hooks/useGetWishes';

type WishDeleteModalProps = {
	open: boolean;
	setOpen: (open: boolean) => void;
};

const WishRemoveModal = ({ open, setOpen }: WishDeleteModalProps) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { id_list, id_wish } = useParams();

	const { wishes } = useGetWishes(parseInt(id_list as string));

	const { deleteWish } = useDeleteWish();
	const { markAsGifted } = useMarkAsGifted();

	const wish = wishes?.find(
		(wish) => wish.id === parseInt(id_wish as string)
	);

	if (!wish) return null;

	return (
		<Dialog open={open} onOpenChange={(open) => setOpen(open)}>
			<DialogContent className="sm:max-w-[425px]">
				<DialogHeader>
					<DialogTitle>{t('wish.form.remove.title')}</DialogTitle>
					<DialogDescription>
						{t('wish.form.remove.description')}
					</DialogDescription>
				</DialogHeader>
				<DialogFooter className="flex flex-col gap-2 sm:flex-col">
					<div className="mb-4 flex items-center justify-center gap-2">
						<Button
							variant="destructive"
							className="w-1/2"
							onClick={() => {
								deleteWish({
									id_wish: parseInt(id_wish as string),
								});
								setOpen(false);
								navigate(`/list/${id_list}`);
							}}
						>
							<Trash className="mr-2 h-4 w-4" />
							{t('common.delete')}
						</Button>
						<span className="py-2 text-sm text-muted-foreground sm:py-0">
							{t('common.or')}
						</span>
						<Button
							className="w-1/2"
							variant="default"
							onClick={() => {
								markAsGifted(wish);
								setOpen(false);
								navigate(`/list/${id_list}`);
							}}
						>
							<Gift className="mr-2 h-4 w-4" />
							{t('wish.form.remove.markAsGifted')}
						</Button>
					</div>
					<Button
						variant="outline"
						type="button"
						onClick={() => setOpen(false)}
					>
						{t('common.cancel')}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};

export default WishRemoveModal;
